import { getSessionTimeoutMinutes, getProfileManageScriptUrl, media } from '~/common';
import { initConfig } from '../common/config';
import Auth from '~/common/Auth';
import Authing from '~/common/Authing';

export const AUTH_TIMEOUT = 'AUTH_TIMEOUT';
export const TOGGLE_ASIDE_MENU = 'TOGGLE_ASIDE_MENU';
export const SET_SESSION_TIMEOUT_MINUTES = 'SET_SESSION_TIMEOUT_MINUTES';
export const SET_PROFILE_MANAGE_SCRIPT_URL = 'SET_PROFILE_MANAGE_SCRIPT_URL';
export const SET_APP_CONFIG = "SET_APP_CONFIG";
export const SET_WINDOW_RESIZE = 'SET_WINDOW_RESIZE';

export const authTimeout = (payload) => ({ type: AUTH_TIMEOUT, payload });
export const toggleAsideMenu = payload => ({ type: TOGGLE_ASIDE_MENU, payload });
export const setSessionTimeoutMinutes = payload => ({ type: SET_SESSION_TIMEOUT_MINUTES, payload });
export const setProfileManageScriptUrl = payload => ({ type: SET_PROFILE_MANAGE_SCRIPT_URL, payload });
export const setAppConfig = payload => ({ type: SET_APP_CONFIG, payload });
export const setWindowResize = payload => ({ type: SET_WINDOW_RESIZE, payload });

const getInitialState = () => {
    let initialState = {
        data: {},
        header: {},
        asideMenu: {},
        sessionTimeoutMinutes: getSessionTimeoutMinutes(),
        profileManageScriptUrl: getProfileManageScriptUrl(),
        config: {},
        configInitialized: false,
        auth: null,
        isMobile: media.isMobile(),
        resizeIndex: 0,
    };
    return initialState;
}

const application = (state = getInitialState(), action) => {
    switch (action.type) {
        case AUTH_TIMEOUT:
            return {
                ...state,
                authTimeout: true,
                authTimeoutCode: action.payload ? action.payload.code : undefined,
                authTimeoutMsg: action.payload ? action.payload.msg : undefined,
            };
        case TOGGLE_ASIDE_MENU:
            return {
                ...state,
                asideMenu: {
                    ...state.asideMenu,
                    collapsed: action.payload,
                }
            };
        case SET_SESSION_TIMEOUT_MINUTES:
            return {
                ...state,
                sessionTimeoutMinutes: action.payload,
            };
        case SET_PROFILE_MANAGE_SCRIPT_URL:
            return {
                ...state,
                profileManageScriptUrl: action.payload,
            };
        case SET_APP_CONFIG:
            const config = action.payload;
            if (!config.authDomain || !config.authClientID || !config.authRedirectUri) {
                console.error('invalid auth config', config);
                return state;
            }
            return {
                ...state,
                config,
                configInitialized: true,
                auth: config.authType == "Authing" ? new Authing(config) : new Auth(config),
            };
        case SET_WINDOW_RESIZE:
            return {
                ...state,
                resizeIndex: state.resizeIndex + 1,
                ...action.payload,
            };
        default: return state;
    }

}

export default application;

